import { useState } from "react";
import * as React from "react";
import { useQueryClient } from "@tanstack/react-query";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

import {
    Plus,
    Trash2,
    SquarePen,
} from "lucide-react";
import {
    RuleVersion,
} from "../../shared/schema";
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "@/components/ui/table";
import { AlertDialog } from "@/widgets/AlertDailog";
import { PaginationControl } from "@/widgets/renderPagination";
import { useLocation } from "wouter";
import { Popup } from "@/widgets/RuleDetailDailog";
import { FilterTypeSearch } from "@/widgets/searchFilterType";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../ui/dropdown-menu";
import { useDeletePartner, useGetPartner } from "@/hooks/useLocalStorage";
import { DeleteConfirmationDialog } from "@/widgets/DeleteModal";
import { parseApiErrorMessage } from "@/hooks/parseApiErrorMessage";
import { Input } from "../ui/input";
import { ConfirmationDialog } from "@/widgets/AlertCommon";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { useBreadcrumbs } from "../BreadcrumbContext";
import { OfferForm, PartnerForm } from "@/shared/partnerschema";
import { AddPartner } from "./AddPartner";

interface TableHierarchicalNodeProps {
    topLevelData: any[];
    pageIndex: number;
    pageSize: number;
    totalCount: number;
    onPageChange: (code: number) => void;
    onEditForm: (data: any) => void;
}

function TableForm({
    topLevelData,
    pageIndex,
    pageSize,
    totalCount,
    onPageChange,
    onEditForm,
}: TableHierarchicalNodeProps) {
    const [currentData, setCurrentData] = useState<OfferForm[]>([]);
    const [alertOpen, setAlertOpen] = React.useState(false);
    const [alertMessage, setAlertMessage] = React.useState("");
    const [reqStatus, setReqStatus] = React.useState(false);
    const [showPopup, setShowPopup] = React.useState(false);
    const [dataHead, setDataHead] = React.useState<RuleVersion | undefined>();
    const [dataContent, setDataContent] = React.useState<string | null>("");
    const [location, setLocation] = useLocation();
    const queryClient = useQueryClient();
    const [popupName, setPopupName] = React.useState("");
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [approveDialogOpen, setApproveDialogOpen] = useState(false);
    const [itemToDelete, setItemToDelete] = useState<OfferForm | null>(null);
    const [itemToPublish, setItemToPublish] = useState<OfferForm | null>(null);

    const deletePortalForm = useDeletePartner()
    const [, navigate] = useLocation();


    React.useEffect(() => {
        if (topLevelData) {
            setCurrentData(topLevelData);
        }
    }, [topLevelData]);

    function handleDeleteClick(e: React.MouseEvent, item: OfferForm) {
        e.stopPropagation();
        setItemToDelete(item);
        setDeleteDialogOpen(true);
    }

    function handleConfirmDelete(authCode?: string) {
        if (!itemToDelete) return;

        // deletePortalForm.mutate({
        //     Id: itemToDelete.FormId,
        //     formType: fromType === "SubForm" ? "sf" : fromType,
        //     authCode: authCode
        // });
    }

    React.useEffect(() => {
        if (deletePortalForm.isSuccess === true) {
            setDeleteDialogOpen(false);
            setReqStatus(deletePortalForm.isSuccess);
            setAlertMessage(`Portal Form deleted Successfully!`);
            setItemToDelete(null);
            setAlertOpen(true);
            deletePortalForm.reset();
        } else if (deletePortalForm.isError) {
            const raw = deletePortalForm.error as Error;
            const parsedMsg = parseApiErrorMessage(raw.message);
            setReqStatus(deletePortalForm.isSuccess);
            setDeleteDialogOpen(false);
            setAlertMessage(parsedMsg);
            setAlertOpen(true);
            deletePortalForm.reset();
        }
    }, [deletePortalForm]);

    return (
        <div>
            <div className="border bg-white border-gray-200 rounded-lg p-2">
                <Table>
                    <TableHeader>
                        <TableRow>
                            <>
                                <TableHead >Offer Id</TableHead>
                                <TableHead >Offer Name</TableHead>
                                <TableHead >Available Raw Rules</TableHead>
                                <TableHead >Rule Value Setup</TableHead>
                                <TableHead >Rule With Values</TableHead>
                                <TableHead >Create Default Offer</TableHead>
                                <TableHead >View Default Offer</TableHead>
                                <TableHead >Additional Offer</TableHead>
                                <TableHead >Last Modified</TableHead>
                                <TableHead >Status</TableHead>
                                <TableHead >Actions</TableHead>
                            </>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {currentData?.map((data) => (
                            <TableRow key={data.Id}>
                                <TableCell className="font-mono">{data.Id}</TableCell>

                                <TableCell className="font-mono">{data.ExchangeOfferName}</TableCell>

                                <TableCell className="px-4 py-3 max-w-xs truncate">
                                    <div className="flex gap-1">
                                        <Button
                                            variant={"link"}
                                            // onClick={() => navigate(`/exchangeoffers/${data.ID}`)}
                                            // onClick={() => navigate(`/exchangeoffers/${data.ID}`, { state: { partnerData: data } })}
                                            className="max-w-xs truncate"
                                        >
                                            View
                                        </Button>
                                    </div>
                                </TableCell>

                                <TableCell className="px-4 py-3 max-w-xs truncate">
                                    <div className="flex gap-1">
                                        <Button
                                            variant={"link"}
                                            // onClick={() => navigate(`/exchangeoffers/${data.ID}`)}
                                            // onClick={() => navigate(`/exchangeoffers/${data.ID}`, { state: { partnerData: data } })}
                                            className="max-w-xs truncate"
                                        >
                                            SetUp
                                        </Button>
                                    </div>
                                </TableCell>

                                <TableCell className="px-4 py-3 max-w-xs truncate">
                                    <div className="flex gap-1">
                                        <Button
                                            variant={"link"}
                                            // onClick={() => navigate(`/exchangeoffers/${data.ID}`)}
                                            // onClick={() => navigate(`/exchangeoffers/${data.ID}`, { state: { partnerData: data } })}
                                            className="max-w-xs truncate"
                                        >
                                            View
                                        </Button>
                                    </div>
                                </TableCell>

                                <TableCell className="px-4 py-3 max-w-xs truncate">
                                    <div className="flex gap-1">
                                        <Button
                                            variant={"link"}
                                            // onClick={() => navigate(`/exchangeoffers/${data.ID}`)}
                                            // onClick={() => navigate(`/exchangeoffers/${data.ID}`, { state: { partnerData: data } })}
                                            className="max-w-xs truncate"
                                        >
                                            Setup Offer
                                        </Button>
                                    </div>
                                </TableCell>

                                <TableCell className="px-4 py-3 max-w-xs truncate">
                                    <div className="flex gap-1">
                                        <Button
                                            variant={"link"}
                                            // onClick={() => navigate(`/exchangeoffers/${data.ID}`)}
                                            // onClick={() => navigate(`/exchangeoffers/${data.ID}`, { state: { partnerData: data } })}
                                            className="max-w-xs truncate"
                                        >
                                            View Offer
                                        </Button>
                                    </div>
                                </TableCell>

                                <TableCell className="px-4 py-3 max-w-xs truncate">
                                    <div className="flex gap-1">
                                        <Button
                                            variant={"link"}
                                            // onClick={() => navigate(`/exchangeoffers/${data.ID}`)}
                                            // onClick={() => navigate(`/exchangeoffers/${data.ID}`, { state: { partnerData: data } })}
                                            className="max-w-xs truncate"
                                        >
                                            Setup Additional Offer
                                        </Button>
                                    </div>
                                </TableCell>

                                <TableCell className="max-w-xs truncate">
                                    <div className="flex flex-col">
                                        {data.CreatedDate ? (
                                            <>
                                                <span>
                                                    {new Date(data.CreatedDate).toLocaleDateString("en-IN", {
                                                        day: "2-digit", month: "short", year: "numeric",
                                                    })}
                                                </span>
                                                <span className="text-xs text-black">
                                                    {new Date(data.CreatedDate).toLocaleTimeString("en-IN", {
                                                        hour: "2-digit", minute: "2-digit",
                                                    })}
                                                </span>
                                            </>
                                        ) : "-"}
                                    </div>
                                </TableCell>

                                <TableCell className="max-w-xs truncate">
                                    <div className="flex flex-col">
                                        {data.ModifiedDate ? (
                                            <>
                                                <span>
                                                    {new Date(data.ModifiedDate).toLocaleDateString("en-IN", {
                                                        day: "2-digit", month: "short", year: "numeric",
                                                    })}
                                                </span>
                                                <span className="text-xs text-black">
                                                    {new Date(data.ModifiedDate).toLocaleTimeString("en-IN", {
                                                        hour: "2-digit", minute: "2-digit",
                                                    })}
                                                </span>
                                            </>
                                        ) : "-"}
                                    </div>
                                </TableCell>

                                <TableCell>
                                    <div className="flex flex-row items-center space-x-2">
                                        <DropdownMenu>
                                            <DropdownMenuTrigger asChild>
                                                <Button
                                                    variant="ghost"
                                                    size="sm"
                                                    className="w-9 h-9 md:w-10 md:h-10 p-0"
                                                    tooltip="More actions"
                                                >
                                                    <Plus size={20} strokeWidth={2.5} />
                                                    <span className="sr-only">More actions</span>
                                                </Button>
                                            </DropdownMenuTrigger>

                                            <DropdownMenuContent align="end" className="min-w-[180px]">

                                                <DropdownMenuItem
                                                    className="flex items-center px-2 cursor-pointer"
                                                    onClick={() => onEditForm(data)}
                                                >
                                                    <SquarePen size={20} strokeWidth={2.5} className="mr-2" />
                                                    <span className="text-sm">Edit Partner</span>
                                                </DropdownMenuItem>

                                                <DropdownMenuItem
                                                    onClick={(e) => handleDeleteClick(e, data)}
                                                    className="flex items-center px-2 cursor-pointer text-red-600 focus:text-red-600 focus:bg-red-50"
                                                >
                                                    <Trash2 size={20} strokeWidth={2.5} className="mr-2" />
                                                    <span className="text-sm">Delete</span>
                                                </DropdownMenuItem>
                                            </DropdownMenuContent>
                                        </DropdownMenu>
                                    </div>
                                </TableCell>

                            </TableRow>
                        ))}
                    </TableBody>
                </Table>

                <div className="mt-2">
                    <PaginationControl
                        pageIndex={pageIndex}
                        pageSize={pageSize}
                        totalCount={totalCount}
                        onPageChange={onPageChange}
                    />
                </div>
            </div>

            <AlertDialog
                open={alertOpen}
                onOpenChange={setAlertOpen}
                message={alertMessage}
                status={reqStatus}
            />

            {showPopup && (
                <Popup
                    popupName={popupName}
                    heading={dataHead}
                    content={dataContent}
                    onClose={() => setShowPopup(false)}
                />
            )}

            <DeleteConfirmationDialog
                open={deleteDialogOpen}
                onOpenChange={setDeleteDialogOpen}
                onConfirm={handleConfirmDelete}
                isPending={deletePortalForm.isPending}
                itemName={(itemToDelete as OfferForm)}
                itemType={"Portal Forms"}
                requireAuthCode={false}
            // requireAuthCode={itemToDelete?.IsActive === true ? false : true}
            />

            {/* <ConfirmationDialog
                open={approveDialogOpen}
                onOpenChange={setApproveDialogOpen}
                onConfirm={handleConfirmPublish}
                isPending={togglePublishMutation.isPending}
                heading={itemToPublish?.Published === true ? "Confirm UnPublished Request" : "Confirm Published Request"}
                message={`Are you sure you want to ${itemToPublish?.Published === true ? "UnPublished" : "Published"} this Form?`}
                confirmLabel={`${itemToPublish?.Published === true ? "UnPublish" : "Publish"}`}
            // cancelLabel="Cancel"
            /> */}
        </div>
    );
}


export function ExchangeOffer() {

    const testdata = [
        {
            "Id": 28,
            "ExchangeOfferName": "gvg",
            "ExPartnerId": 86,
            "OfferDetails": "yugvhbn",
            "CreatedDate": "2026-06-03T10:46:52.437000",
            "ModifiedDate": "2026-06-03T10:46:52.437000",
            "IsActive": false,
            "ReferenceFormId": null
        },
        {
            "Id": 18,
            "ExchangeOfferName": "RD Raised Rates",
            "ExPartnerId": 86,
            "OfferDetails": "RD raised ",
            "CreatedDate": "2026-03-10T10:57:17.310000",
            "ModifiedDate": "2026-03-10T11:00:26.360000",
            "IsActive": false,
            "ReferenceFormId": 152
        },
        {
            "Id": 15,
            "ExchangeOfferName": "FD Slashes",
            "ExPartnerId": 86,
            "OfferDetails": "8% FDs",
            "CreatedDate": "2026-03-10T07:50:27.513000",
            "ModifiedDate": "2026-03-10T07:50:27.513000",
            "IsActive": false,
            "ReferenceFormId": null
        }
    ]

    const { setBreadcrumbs } = useBreadcrumbs();
    const [topLevelTypes, setTopLevelTypes] = useState<OfferForm[]>([]);

    const [typeInput, setTypeInput] = useState<string>("");
    const [filterOpen, setFilterOpen] = useState(false);
    const [filterTypeData, setFilterTypeData] = useState<OfferForm[]>([]);
    const [filterName, setFilterName] = useState<string>("");

    const [formNameInput, setFormNameInput] = useState<string>("");
    const [formCodeInput, setFormCodeInput] = useState<number | undefined>();

    const [formName, setFormName] = useState<string | undefined>();
    const [partnerTypeInput, setpartnerTypeInput] = useState<string | undefined>("");
    const [partnerType, setPartnerType] = useState<string | undefined>("");
    const [offerId, setOfferId] = useState<string | null>(null);
    const [formCode, setFormCode] = useState<string | undefined>();
    const [formType, setFormType] = useState<string>("");
    const [offerCookieData, setOfferCookieData] = useState<any>(null);

    // Form dialog states - controlled from parent
    const [openCreateDialog, setOpenCreateDialog] = useState(false);
    const [editFormData, setEditFormData] = useState<any>(null);

    // pagination states
    const [pageIndex, setPageIndex] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalCount, setTotalCount] = useState(10);

    const { data: types, isLoading } = useGetPartner(
        pageIndex,
        pageSize,
        formCode,
        formName,
        partnerType,
    );
    console.log("offerId", offerId)
    // const { data: partners } = usePartnerData(
    //     1,
    //     undefined,
    // );

    React.useEffect(() => {
        setBreadcrumbs([
            {
                label: `Partners`,
                path: `/`,
            },
        ]);
    }, []);


    React.useEffect(() => {
        // setTopLevelTypes(types?.data.items ?? []);
        setTopLevelTypes(testdata ?? []);
        // setTotalCount(types?.data.total ?? 0);
    }, [testdata]);

    //   const { data: filterTypes, isFetching: isFilterFetching } = useFilterForms(
    //     filterName.length >= 3 ? filterName : "",
    //     pageSize,
    //     fromType === "SubForm" ? "sf" : fromType
    //   );

    //   React.useEffect(() => {
    //     if (filterTypes && filterTypes.length > 0) {
    //       setFilterTypeData(filterTypes)
    //     } else {
    //       setFilterTypeData([])
    //     }
    //   }, [filterTypes])

    const handleSearch = () => {
        setFormName(typeInput || undefined);
        setFormCode(formCodeInput);
        setPartnerType(partnerTypeInput);
        setPageIndex(1);
    };

    const handleRefresh = (close: boolean) => {
        setFormNameInput("");
        setPartnerType("");
        setFormCodeInput(undefined);
        setTypeInput("")

        setFormName(undefined);
        setFormCode(undefined);
        setpartnerTypeInput("")

        setPageIndex(1);
        if (close) setFilterOpen(false);
    };

    const handleAddForm = () => {
        setEditFormData(null);
        setOpenCreateDialog(true);
    };

    const handleEditForm = (data: any) => {
        setEditFormData(data);
        setOpenCreateDialog(true);
    };

    return (
        <div className="min-h-full">
            <div className="mb-4 md:mb-6">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-3 sm:space-y-0">
                    <div className="min-w-0">
                        <h2 className="text-lg md:text-xl font-semibold text-black">
                            Manage XChange Set up
                        </h2>
                        <p className="text-black mt-1 text-sm md:text-base">
                            XChange Partners Linked:
                        </p>
                    </div>

                    <div className="flex items-center space-x-2 md:space-x-3 flex-shrink-0">
                        {/* <Button
                            className="bg-workfinity-500 hover:bg-workfinity-600 text-sm md:text-base"
                            size="sm"
                            onClick={() => setFilterOpen(true)}
                        >
                            Filter
                        </Button> */}

                        <Button
                            className="bg-workfinity-500 hover:bg-workfinity-600 text-sm md:text-base"
                            size="sm"
                            onClick={handleAddForm}
                        >
                            <Plus className="h-3 w-3 md:h-4 md:w-4 mr-2" />
                            Add Offer
                        </Button>
                    </div>
                </div>
            </div>
            <div>
                {filterOpen &&
                    <Card className="mb-4 md:mb-6">
                        <CardContent className="pt-0">
                            <div className="flex flex-col md:flex-row md:items-center md:space-x-4 space-y-3 md:space-y-0">
                                <div className="w-[450px]">
                                    <FilterTypeSearch
                                        filterTypeData={filterTypeData}
                                        isLoading={isLoading}
                                        value={typeInput}
                                        onChange={setTypeInput}
                                        onSearch={(query) => setFilterName(query)}
                                    />
                                </div>
                                <div className="w-[450px]">
                                    <Input
                                        type="number"
                                        placeholder="Form ID"
                                        value={formCodeInput ?? ""}
                                        onChange={(e) =>
                                            setFormCodeInput(
                                                e.target.value ? Number(e.target.value) : undefined
                                            )
                                        }
                                    />
                                </div>
                                <div className="w-[450px]">
                                    <Select
                                        value={partnerTypeInput}
                                        onValueChange={(value) => setpartnerTypeInput(value)}
                                    >
                                        <SelectTrigger>
                                            <SelectValue placeholder="Select Partner" />
                                        </SelectTrigger>

                                        {/* <SelectContent>
                                            {partners?.data?.items?.map((partner: any) => (
                                                <SelectItem
                                                    key={partner.ID}
                                                    value={partner.ID.toString()}
                                                >
                                                    {partner.PartnerName}
                                                </SelectItem>
                                            ))}
                                        </SelectContent> */}
                                    </Select>
                                </div>
                            </div>

                            <div className="mt-4 flex justify-center space-x-2">
                                <Button onClick={handleSearch}>Search</Button>
                                <Button variant="outline" onClick={() => handleRefresh(false)}>
                                    Refresh
                                </Button>
                                <Button variant="outline" onClick={() => handleRefresh(true)}>
                                    Close
                                </Button>
                            </div>
                        </CardContent>
                    </Card>
                }
            </div>

            {!isLoading ? (
                <Card>
                    <CardContent className="p-4 md:p-6">
                        <div className="space-y-2">
                            {topLevelTypes && topLevelTypes.length > 0 ? (
                                <>
                                    <TableForm
                                        topLevelData={topLevelTypes}
                                        pageIndex={pageIndex}
                                        pageSize={pageSize}
                                        totalCount={totalCount}
                                        onPageChange={setPageIndex}
                                        onEditForm={handleEditForm}
                                    />
                                </>
                            ) : (
                                <div className="text-center py-8 text-black">
                                    <p>No Offers found. Create to get started.</p>
                                </div>
                            )}
                        </div>
                    </CardContent>
                </Card>
            ) : (
                <div className="p-6 text-black">Loading...</div>
            )}

            {/* <CreateFormDialog
                open={openCreateDialog}
                onOpenChange={setOpenCreateDialog}
                initialData={editFormData}
                fromType={fromType}
                offerData={(fromType === "DefaultOffer" || fromType === "AdditionalOffer") ? offerCookieData : null}
            /> */}
            <AddPartner
                open={openCreateDialog}
                onOpenChange={setOpenCreateDialog}
                initialData={editFormData}
            />
        </div>
    );
}